import React from 'react';
import PropTypes from 'prop-types';

import MuiTypography from '@mui/material/Typography';
import { sxPropType } from '../../proptypes/misc';

function Typography({ sx, children, variant, ...other }) {
  return (
    <MuiTypography
      variant={variant}
      sx={[
        (theme) => ({
          '& a': {
            color: theme.palette.secondary.main,
            textDecoration: 'none',
            '&:focus, &:hover': {
              textDecoration: 'underline',
            },
          },
          '& > img': {
            borderRadius: '25px',
            transform: 'translateZ(0)',
            width: 'calc(100% + 48px)',
            maxHeight: '700px',
            objectFit: 'contain',
            margin: '0 -24px',
            [theme.breakpoints.down('md')]: {
              borderRadius: '0',
            },
          },
        }),
        variant === 'h1' && {
          '& .MuiTypography-gutterBottom': {
            marginBottom: '24px',
          },
        },
        (variant === 'body1' || variant === 'body2') && {
          '& .MuiTypography-paragraph': {
            marginBottom: '24px',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </MuiTypography>
  );
}

Typography.propTypes = {
  sx: sxPropType,
  variant: PropTypes.string,
  children: PropTypes.node,
};

Typography.defaultProps = {
  sx: [],
  variant: 'inherit',
  children: undefined,
};

export default Typography;
